import React, { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { CustomFieldBuilder } from "../../containers/utilities/CustomFieldBuilder";
import { isMultiSelectField } from "../../constants/field-ui-type";
import { WizardSummaryLayout } from '../../components/wizard/wizard-summary-layout';

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    supportedFields?: any[];
    templateName: string
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined, supportedFields = undefined, templateName }) => {
    const { translate } = useLocale();
    const formik = useFormikContext<any>();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);
    const detailFields = supportedFields?.filter(field => !isMultiSelectField(field.fieldTypeId)) || [];
    const multiSelectFields = supportedFields?.filter(filter => isMultiSelectField(filter.fieldTypeId)) || [];
    
    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)} onSubmit={onNext ? (e) => onNext(e) : undefined}>
            <div className="flex flex-col">
                <span className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.description)}:</span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.name)}: <span className="text-sm text-black">{formik.values.name}</span></span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.type)}: <span className="text-sm text-black">{templateName}</span></span>
                {detailFields && detailFields.length > 0
                    ? detailFields.reduce((formFields, field) => customFieldBuilder.buildSummaryField(formFields, field), new Array(0))
                        .map(fieldBundle => {
                            return fieldBundle.length === 1
                                ? fieldBundle[0].span
                                    ? fieldBundle[0].content
                                    : <>{fieldBundle[0].content}</>
                                : fieldBundle.map(field => field.content)
                        })
                    : <span>{translate.byKey(TranslationKeys.noContent)}</span>}
            </div>
            
            {/* Multi-select option */}
            {multiSelectFields && multiSelectFields.length > 0 && multiSelectFields.map((field) => {
                const fieldValue = formik.values.custom?.[field.systemName];
                const selectedNames = Array.isArray(fieldValue?.names) ? fieldValue.names : [];
                const hasSelectedValues = selectedNames.length > 0;

                return (hasSelectedValues && (<>
                    <hr />
                    <div className="flex flex-col pt-3" key={field.systemName}>
                        <span className="p-1 text-lg font-bold">{field.displayName}</span>
                        <span className="p-1 text-xs text-gray-600">
                            {
                                Object.keys(formik.values.custom).length > 0 && formik.values.custom[field.systemName]["names"] && Array.isArray(formik.values.custom[field.systemName]["names"]) ?
                                    formik.values.custom[field.systemName]["names"].join(", ") :
                                    formik.values.custom[field.systemName]
                            }
                        </span>
                    </div>
                    <hr />
                </>));
            })}

            {/* Triggered By */}
            {formik.values.triggeredByNames && formik.values.triggeredByNames.length > 0 && <>
                <hr />
                <div className="flex flex-col pt-3" key={"triggered-by"}>
                    <span className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.triggeredBy)}</span>
                    <span className="p-1 text-xs text-gray-600">{formik.values.triggeredByNames.join(", ")}</span>
                </div>
                <hr />
            </>}
    </WizardSummaryLayout>;
};
